import { MsalProvider } from "@azure/msal-react";
import { QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "@tanstack/react-router";
import { Toaster } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { ErrorBoundary } from "@/components/shared/error-boundary";
import { AuthGate } from "@/components/shared/auth-gate";
import { CurrentUserProvider } from "@/components/shared/current-user-provider";
import { msalInstance } from "@/lib/auth";
import { queryClient } from "@/lib/query-client";
import { router } from "@/router";

export function App() {
  return (
    <ErrorBoundary>
      <MsalProvider instance={msalInstance}>
        <AuthGate>
          <QueryClientProvider client={queryClient}>
            <CurrentUserProvider>
              <TooltipProvider delayDuration={300}>
                <RouterProvider router={router} />
                <Toaster />
              </TooltipProvider>
            </CurrentUserProvider>
          </QueryClientProvider>
        </AuthGate>
      </MsalProvider>
    </ErrorBoundary>
  );
}
